import { useState } from 'react';
import { FieldValues, Path, useFormContext } from 'react-hook-form';
import { InputRadio } from '@components/input-radio';

import { GroupRadioSelectorProps } from './group-radio-selector.type';

export const GroupRadioSelector = <T extends FieldValues>({
  options,
  name,
  onChange,
  containerClassName = 'flex-1 p-6 border bg-primary rounded-lg',
}: GroupRadioSelectorProps) => {
  const formContext = useFormContext?.();
  const watch = formContext?.watch;
  const [localValue, setLocalValue] = useState<string>('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!watch) {
      setLocalValue(e.target.value);
    }
    onChange?.(e);
  };

  return (
    <div className='flex flex-col md:flex-row gap-4 mb-3'>
      {options.map((option) => (
        <InputRadio
          key={option.label}
          id={option.name}
          name={name}
          label={option.label}
          value={option.value}
          checked={watch ? watch(name as Path<T>) === option.value : localValue === option.value}
          containerClassName={containerClassName}
          onChange={handleChange}
        />
      ))}
    </div>
  );
};
